/*!
 *
 *	menu.js
 *
 */

var topVideo = {
	init: function(){
		this.movie = document.getElementById("visual_movie");
		if (!this.movie) return;
		var self = this;
		var wrapperHeight = self.movie.clientHeight;

		$(window).on('changePC', function() {
			window.addEventListener('resize', self.resizeElem);
		})
		$(window).on('changeMobile', function() {
			window.removeEventListener('resize', self.resizeElem);
			self.resizeElem();
		})
		if (!origin.VPisMobile) {
			window.addEventListener('resize', self.resizeElem);
			this.resizeElem();
		}
		this.movie.addEventListener("timeupdate", function(){
			if (this.currentTime > 29.5) {
				this.currentTime = 0;
			}
		}, false);

	},
	resizeElem: function() {
		var targetWidth = 1280;
		var targetHeight = 720;
		var scale = Math.max(origin.ww / targetWidth, origin.wh / targetHeight);
		var setWidth = Math.floor(targetWidth * scale);
		var setHeight = Math.floor(targetHeight * scale);
		this.wrapper = document.getElementById("visual");
		this.inner = $(".top_visual_movie");
		this.movie = document.getElementById("visual_movie");

		var _h = origin.wh;
		if(origin.VPisMobile){
			_h = 'auto';
		};

		$(this.wrapper).removeAttr('style').css({
			'height': _h
		});
		this.inner.removeAttr('style').css({
			'height': _h
		});
		$(this.movie).removeAttr('style').css({
			'width':setWidth,
			'height':setHeight,
			'left':Math.floor((origin.ww - setWidth) / 2),
			'top':Math.floor((origin.wh - setHeight) / 2)
		});
	}

};

module.exports = topVideo;



//////////////////
// WEBPACK FOOTER
// ./dev/dcms_media/js/components/module/top-video.js
// module id = 13
// module chunks = 0